import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _14mpIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"14mp"} ref={ref}/>
});

_14mpIcon.displayName = "_14mpIcon";
